import { render, staticRenderFns } from "./WAWebhooks.vue?vue&type=template&id=4c1de0db&"
import script from "./WAWebhooks.vue?vue&type=script&lang=js&"
export * from "./WAWebhooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports